module.exports = __webpack_public_path__ + "assets/img/alert_suc.492787a8.png";